import React from 'react';
import { projects } from '../data/mockData';
import { Calendar, ArrowRight, CheckCircle, Clock, Zap } from 'lucide-react';
import { Badge } from '../components/ui/badge';

const statusConfig = {
  'In corso': { color: 'bg-yellow-600', icon: Clock },
  'Prossimamente': { color: 'bg-blue-600', icon: Zap },
  'Attivo': { color: 'bg-green-600', icon: CheckCircle },
  'Completato': { color: 'bg-gray-600', icon: CheckCircle }
};

const ProgettiPage = () => {
  return (
    <div className="py-10 sm:py-16 px-4" style={{ backgroundColor: 'var(--tp-black)', minHeight: '80vh' }}>
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-2 text-white"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          PROGETTI
        </h1>
        <div className="w-20 h-1 mx-auto mb-4" style={{ backgroundColor: 'var(--tp-red)' }} />
        <p className="text-center text-gray-400 mb-8 sm:mb-12 max-w-xl mx-auto text-sm sm:text-base">
          I nostri progetti attivi e futuri per promuovere la cultura Hip Hop e il freestyle in Italia.
        </p>

        <div className="space-y-8">
          {projects.map((project, i) => {
            const status = statusConfig[project.status] || statusConfig['Attivo'];
            const StatusIcon = status.icon;
            return (
              <div key={project.id}
                className="rounded-lg overflow-hidden border border-gray-800 hover:border-red-600 transition-all duration-300 group"
                style={{ backgroundColor: 'var(--tp-dark)' }}>
                <div className="flex flex-col md:flex-row">
                  <div className="md:w-80 h-56 md:h-auto relative overflow-hidden flex-shrink-0">
                    <img src={project.image} alt={project.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute top-3 left-3">
                      <Badge className={`${status.color} text-white gap-1`} style={{ fontFamily: 'Oswald, sans-serif' }}>
                        <StatusIcon size={12} /> {project.status}
                      </Badge>
                    </div>
                  </div>
                  <div className="p-6 md:p-8 flex flex-col justify-center">
                    <h3 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: 'Oswald, sans-serif' }}>
                      {project.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed mb-6">
                      {project.description}
                    </p>
                    <div className="flex items-center gap-2 text-red-400 text-sm group-hover:translate-x-2 transition-transform duration-300">
                      <span className="font-medium" style={{ fontFamily: 'Oswald, sans-serif' }}>SCOPRI DI PIÙ</span>
                      <ArrowRight size={14} />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProgettiPage;
